export default {
  adminNavigation: {
      "dashboard": "Dashboard",
      "applications": "Applications",
      "channelApplications": "Channel apps",
      "homeApplications": "Home apps",
      "customerApplications": "Customer apps",
      "customers": "Customers",
      "customerList": "Customer list",
      "referredCustomers": "Referred customers",
      "orders": "Orders",
      "plans": "Plans & compute",
      "marketing": "Marketing",
      "marketingMembers": "Marketing members",
      "redemptionCodes": "Redemption codes",
      "companies": "Companies",
      "companyPlans": "Company plans",
      "workflows": "Workflows",
      "labels": "Labels",
      "categories": "Categories",
      "agents": "Agents",
      "computeRules": "Compute rules",
      "content": "Content",
      "gpuPools": "GPU pools",
      "tasks": "Tasks",
      "internationalSite": "International site",
      "domesticSite": "Domestic site"
  }
};
